import { render, staticRenderFns } from "./DataConsentTrainer.vue?vue&type=template&id=6a4a9143&"
import script from "./DataConsentTrainer.vue?vue&type=script&lang=js&"
export * from "./DataConsentTrainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports